var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrap"},[_c('css-import-write-file',{attrs:{"cssStr":_vm.cssStr},on:{"file-upload":_vm.handleFileUpload}}),_c('css-import-upload-file',{on:{"file-upload":_vm.handleFileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }